export default "__VITE_ASSET__412b0ff8__"